import React from 'react';

//MUI
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Typography, Rating } from '@mui/material';

class CustomerReviewInfo extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Card variant="outlined" sx={{ minWidth: 275, mt: 1 }}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={3} sx={{ display: 'flex' }}>
                      Автор отзыва:
                    </Grid>
                    <Grid item xs={9}>
                      <Typography component="div">
                        {this.props.review.author}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={3} sx={{ display: 'flex' }}>
                      Оценка:
                    </Grid>
                    <Grid item xs={9}>
                      <Rating value={this.props.review.rating} precision={1} readOnly />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={3} sx={{ display: 'flex' }}>
                      Отзыв:
                    </Grid>
                    <Grid item xs={9}>
                      <Typography component="div">
                        {this.props.review.text}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
        </Card>
      </React.Fragment>
    )
  }
}

export default CustomerReviewInfo;
